export const enum YesNoChoice {
  YES = 'DV-3#0',
  NO = 'DV-3#1',
}

export const DV_3 = {
  id: 'DV-3',
  description: {
    fr: 'Oui / Non',
    en: 'Yes / No',
  },
  type: 'boolean',
  values: [
    {
      id: '0',
      properties: {
        booleanValue: true,
      },
      value: {
        fr: 'Oui',
        en: 'Yes',
      },
    },
    {
      id: '1',
      properties: {
        booleanValue: false,
      },
      value: {
        fr: 'Non',
        en: 'No',
      },
    },
  ],
};
